export const SCHEME_SUBTYPES = { standard: "Standard Scheme", eminent: "Eminent Scheme", secret: "Secret Scheme", legendary_schemer: "Legendary Schemer", grand: "Grand Scheme" };
export const CUSTOM_SCHEME_TYPES = ["eminent", "secret", "legendary_schemer", "grand"];
export const SCHEME_HELP = {
  eminent: "Revealed publicly, waits in Public Pending until the Archenemy sets it in motion at sorcery speed.",
  secret: "The Archenemy looks first; Secret Schemes wait face down and can be revealed at instant speed.",
  legendary_schemer: "Command-zone foe with loyalty. Not a permanent or planeswalker. One per Archenemy.",
  grand: "Stays in play like an ongoing scheme and pauses normal scheme reveals until abandoned.",
};
export const LAYOUT_PREFS = { mixed: "Layout: mixed (default)", landscape: "Layout: prefer landscape", portrait: "Layout: prefer portrait", oversized: "Layout: prefer oversized", custom: "Layout: prefer custom sizes" };

export const isScheme = (sp) => sp === "scheme" || sp === "ongoing_scheme";

export function schemeTypeLine(kind, sub) {
  const ongoing = kind === "ongoing_scheme" ? "Ongoing " : "";
  if (!sub || sub === "standard") return `${ongoing}Scheme`;
  return `${ongoing}${SCHEME_SUBTYPES[sub]}`;
}
